export default "__VITE_ASSET__D7BxZ8Uo__"